'use client';
import { PlaceImage } from "@/components/PlaceImage";
import { Title } from "@/components/Title";
import { useState } from "react";

// Pilgrimage
import mecca from "../../../assets/Image/international-tour/saudi-arabia/mecca.jpg";
import madinah from "../../../assets/Image/international-tour/saudi-arabia/madinah.jpg";
import Al_Aqsa_Mosque from "../../../assets/Image/international-tour/common/Al_Aqsa_Mosque.jpg"
import karbala from "../../../assets/Image/international-tour/Iraq/karbala.jpg"
import lumbini from "../../../assets/Image/international-tour/common/lumbini.jpg"
import rishikesh from "../../../assets/Image/domestic-tours/rishikesh.png"
import Golden_Temple from "../../../assets/Image/domestic-tours/Golden_Temple.jpg"
import varanasi from "../../../assets/Image/domestic-tours/varanasi.jpg"
 
// import Pilgrimage from "../../../assets/Image/Pilgrimage1.png"
// import Pilgrimage2 from "../../../assets/Image/Pilgrimage2.png"
// import Pilgrimage3 from "../../../assets/Image/aboutheaderimage.png"
import { StaticImageData } from "next/image";

// 7 Wonders of the World
import greatWallOfChina from "../../../assets/Image/populer-places/seven-wonders/Great-Wall-of-China-Beijing.jpg"
import Colosseum from "../../../assets/Image/populer-places/seven-wonders/Colosseum.jpg"
import tajMahal from "../../../assets/Image/populer-places/seven-wonders/Taj-Mahal.jpg"
import statueChrist from "../../../assets/Image/populer-places/seven-wonders/statue-Christ.jpg"
import machuPicchu from "../../../assets/Image/populer-places/seven-wonders/Machu-Picchu.jpg"
import elCastilloPyramid from "../../../assets/Image/populer-places/seven-wonders/El-Castillo-pyramid.jpg"
import khaznahPetraJordan from "../../../assets/Image/populer-places/seven-wonders/Khaznah-Petra-Jordan.jpg"

// Famous Cities
import Paris from "../../../assets/Image/international-tour/france/paris.jpg";
import newYork from "../../../assets/Image/populer-places/famous-cities/New-York.jpg";
import Kyoto from "../../../assets/Image/international-tour/Japan/kyoto.jpg";
import London from "../../../assets/Image/populer-places/famous-cities/London.jpg";
import dubai from "../../../assets/Image/international-tour/dubai/dubai.jpg";
import Rome from "../../../assets/Image/populer-places/famous-cities/Rome.jpg";
import Istanbul from "../../../assets/Image/populer-places/famous-cities/Istanbul.jpg";
import Barcelona from "../../../assets/Image/populer-places/famous-cities/Barcelona.jpg";

// Beach & Island Escapes
import Bali from "../../../assets/Image/international-tour/Indonesia/bali.jpg";
import Maldives from "../../../assets/Image/populer-places/beach-island/Maldives.jpg";
import amalfiCoast from "../../../assets/Image/populer-places/beach-island/amalfi-coast.jpg";
import boraBora from "../../../assets/Image/populer-places/beach-island/bora-bora.jpg";
import phuket from "../../../assets/Image/populer-places/beach-island/phuket.jpg";
import santorini from "../../../assets/Image/populer-places/beach-island/santorini.jpg";

type Place = {
  title: string;
  image: StaticImageData;
};
type CategoryData = {
  [category: string]: Place[];
};
export const PopularPlaces = () => {
  const categoryData: CategoryData = {
    "Seven Wonders of the World": [
      { title: "Great Wall of China", image: greatWallOfChina },
      { title: "Petra ", image: khaznahPetraJordan },
      { title: "Christ the Redeemer", image: statueChrist },
      { title: "Machu Picchu", image: machuPicchu },
      { title: "Chichen Itza", image: elCastilloPyramid },
      { title: "Roman Colosseum", image: Colosseum },
      { title: "Taj Mahal", image: tajMahal },
    ],
    "Pilgrimage": [
      { title: "Mecca ", image: mecca },
      { title: "Medina  ", image: madinah },
      { title: "Jerusalem", image: Al_Aqsa_Mosque },
      { title: "Karbala", image: karbala },
      { title: "Lumbini  ", image: lumbini },
      { title: "Rishikesh & Haridwar  ", image: rishikesh },
      { title: "Golden Temple (Amritsar)", image: Golden_Temple },
      { title: "Varanasi ", image: varanasi },
    ],
    "Famous Cities": [
      { title: "Paris", image: Paris },
      { title: "New York", image: newYork },
      { title: "Kyoto", image: Kyoto },
      { title: "London", image: London },
      { title: "dubai", image: dubai },
      { title: "Rome", image: Rome },
      { title: "Istanbul", image: Istanbul },
      { title: "Barcelona", image: Barcelona },
    ],
    "Beach & Island": [
      { title: "Bali", image: Bali },
      { title: "Maldives", image: Maldives },
      { title: "Amalfi Coast", image: amalfiCoast },
      { title: "Bora Bora", image: boraBora },
      { title: "Phuket ", image: phuket },
      { title: "Seychelles", image: santorini },
    ],
  };
  const categories = Object.keys(categoryData);
  const [selectedCategory, setSelectedCategory] = useState<string>("Seven Wonders of the World");
  return (
    <div className="container">
      <Title header='POPULAR PLACES'
        // subtitle="Discover the Most Stunning Places on Earth"
        subtitle="Top Destinations to Fall in Love With"
      />
      <div className="flex flex-col items-center">
        {/* Category Tabs */}
        <div className="flex gap-2 md:gap-6 flex-wrap justify-center">
          {categories.map((category) => (
            <div
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`cursor-pointer transition-all 
                ${selectedCategory === category
                  ? 'earth-name  border-0 font-bold'
                  : 'py-[5px] text-dark-gray font-semibold'
                }`}
            >
              <p>{category}</p>
            </div>
          ))}
        </div>
        {/* Selected Category Display */}
        {selectedCategory && (
          <div className="w-full pt-8 md:pt-14">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">

              {categoryData[selectedCategory].map((item: Place, index: number) => (
                <div key={`${item.title}-${index}`}>
                  <PlaceImage img={item.image} imgtitle={item.title} aspectRatio="415/415" />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
